import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SocketProvider } from './context/SocketContext';
import GlobalCallNotificationWrapper from './Components/VideoCall/GlobalCallNotificationWrapper';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Register from './Components/Pages/Register/Register';
import Home from './Components/Home/Home';
import Navbar from "./Components/Pages/Navbar/JobSeekerNavbar";
import AboutUs from "./Components/AboutUs/AboutUs";
import ContactUs from "./Components/ContactUs/ContactUs";
import Footer from "./Components/Footer/Footer";
import TipsNews from "./Components/TipsNews/TipsNews";
import EmployerNavbar from "./Components/Pages/Navbar/EmployerNavbar";
import Login from "./Components/Pages/Login/Login";

import PersonalInfo from './Components/JobSeeker/ResumeUpdate/PersonalInfo/PersonalInfo';
import ContactDetails from "./Components/JobSeeker/ResumeUpdate/DetailsYourself/ContactDetails";
import ProfessionalInfo from './Components/JobSeeker/ResumeUpdate/ProfessionalInfo/ProfessionalInfo';
import PreferenceForJob from './Components/JobSeeker/ResumeUpdate/preferenceForJob/preferenceForJob';
import MySkills from './Components/JobSeeker/ResumeUpdate/MySkills/MySkills';
import PreviousExperience from './Components/JobSeeker/ResumeUpdate/PreviousExperience/PreviousExperience';
import Education from './Components/JobSeeker/ResumeUpdate/Education/Education';
import ResumeDescription from './Components/JobSeeker/ResumeUpdate/ProvideDetails/ResumeDescription';
import UploadVideo from './Components/JobSeeker/ResumeUpdate/UploadVideo/UploadVideo';
import ChoosePhoto from "./Components/JobSeeker/ResumeUpdate/ChoosePhoto/ChoosePhoto";
import ViewJobs from './Components/JobSeeker/ViewJobs/ViewJobs';
import JobDetails from './Components/JobSeeker/ViewJobs/JobDetails';
import JobSeekerMessages from './Components/JobSeeker/Messages/JobSeekerMessages';
import AppliedJobs from './Components/JobSeeker/AppliedJobs/AppliedJobs';
import AppliedJobDetails from './Components/JobSeeker/AppliedJobs/AppliedJobDetails';
import JobSeekerDashboard from "./Components/JobSeeker/Dashboard/Dashboard";
import ProfileCard from "./Components/JobSeeker/ProfileCard/ProfileCard";
import MyAccount from './Components/JobSeeker/MyAccount/MyAccount';
import CombinedProfileCard from './Components/JobSeeker/CombinedProfileCard/CombinedProfileCard';
import PreferredCountry from './Components/JobSeeker/ResumeUpdate/DoctorProfile/JobPreference/JobPreference';

import EmployerDashboard from "./Components/Employer/Dashboard/Dashboard"
import BasicInfo from './Components/Employer/BasicInformation/BasicInfo';
import RequiredSkills from './Components/Employer/RequiredSkills/RequiredSkills';
import CandidatePreference from './Components/Employer/CandidatePreference/CandidatePreference';
import AboutYourself from './Components/Employer/AboutYourself/AboutYourself';
import JobDescription from './Components/Employer/JobDescripotion/JobDescription';
import ViewJobposting from './Components/Employer/ViewJobposting/ViewJobposting';
import ViewJobDetails from './Components/Employer/ViewJobposting/JobDetails';
import EmployerMessages from './Components/Employer/Messages/EmployerMessages';
import SendAlert from './Components/Employer/SendAlert/SendAlert';
import AgencySendAlert from './Components/Agency/SendAlert/SendAlert';
import AgencyMessages from './Components/Agency/Messages/AgencyMessages';
import Candidates from './Components/Employer/Candidates/Candidates';
import CandidateView from './Components/Employer/Candidates/CandidateView';
import AddProfilePhoto from './Components/Employer/AddProfilePhoto/AddProfilePhoto';
import MyProfile from './Components/Employer/Profile/MyProfile';
import AllJobs from './Components/Home/Jobs/ViewJobs';
import AllJobDetails from './Components/Home/Jobs/JobDetails';
import EuropeanJobs from './Components/Home/EuropeanJobs/EuropeanJobs';

import AgencyRegistration from './Components/OtherPages/AgencyRegistration/AgencyRegistration';
import NewAgencyDashboard from './Components/Agency/AgencyDashboard/NewAgencyDashboard1';
import AddJobSeeker from './Components/Agency/JobSeekerRegistration/AddJobSeeker';
import JobSeekerRegistration from './Components/Agency/JobSeekerRegistration/JobSeekerRegistration';
import Personalinfo from './Components/Agency/JobSeekerResumeUpdate/Personalinfo';
import Contactdetails from './Components/Agency/JobSeekerResumeUpdate/Contactdetails';
import Professionalinfo from './Components/Agency/JobSeekerResumeUpdate/Professionalinfo';
import Preferenceforjob from './Components/Agency/JobSeekerResumeUpdate/Preferenceforjob';
import Myskills from './Components/Agency/JobSeekerResumeUpdate/Myskills';
import Previousexperience from './Components/Agency/JobSeekerResumeUpdate/Previousexperience';
import Education1 from './Components/Agency/JobSeekerResumeUpdate/Education1';
import Resume from './Components/Agency/JobSeekerResumeUpdate/Resume';
import Uploadvideo from './Components/Agency/JobSeekerResumeUpdate/Uploadvideo';
import Choosephoto from './Components/Agency/JobSeekerResumeUpdate/Choosephoto';

import ReportJobForm from './Components/JobSeeker/ReportJob/ReportJob';
import CandidateCard from './Components/CandidateCard/CandidateCard'
import CandidateCard2 from './Components/OtherPages/CandidateCard2/CandidateCard2'
import CandidateCard3 from './Components/OtherPages/CandidateCard3/CandidateCard3';
import JobPost from './Components/OtherPages/JobPost/JobPost';
import CandidatePosting from "./Components/OtherPages/CandidatePosting/CandidatePosting"
import CandidateNursing from "./Components/OtherPages/CandidateNursing/CandidateNursing"
import MultiSkilledCandidate from './Components/OtherPages/MultiSkilledCandidate/MultiSkilledCandidate';
import CandidateCard4 from './Components/OtherPages/CandidateCard4/CandidateCard4';
import AgencyCard from './Components/OtherPages/AgencyCard/AgencyCard'
import AgencyList from './Components/Home/Agency/AgencyList';
import FreeJobPost from "./Components/OtherPages/FreeJobPost/FreeJobPost"
import EmployeeCardNew from './Components/OtherPages/EmployeeCardNew/EmployeeCardNew';
import JobListing from "./Components/OtherPages/JobListing/JobListing"
import SingleJobListing from './Components/OtherPages/SingleJobListing/SingleJobListing';
import AppliedCandidates from './Components/Employer/AppliedCandidates/AppliedCandidates';
import ViewCandidates from './Components/Agency/ViewCandidates/ViewCandidates';

import AgencyViewCandidates from './Components/Agency/ViewCandidates/AgencyViewCandidates';
import AgencyMyaccount from './Components/Agency/AgencyMyAccount/AgencyMyaccount';
import JobPosting from './Components/Agency/JobPosting/JobPosting';
import AgencyViewJobDetails from './Components/Agency/JobPosting/ViewJobDetails';
import AgencyBasicInfo from './Components/Agency/JobPosting/BasicInfo';
import AgencyRequiredSkills from './Components/Agency/JobPosting/RequiredSkills';
import AgencyCandidatePreference from './Components/Agency/JobPosting/CandidatePreference';
import AgencyAboutYourself from './Components/Agency/JobPosting/AboutYourself';
import AgencyJobDescriptionForm from './Components/Agency/JobPosting/JobDescription';
import AdminLeadBotLeads from './Components/Admin/LeadBotLeads/AdminLeadBotLeads';
import AdminPayments from './Components/Admin/Payments/AdminPayments';
import AgencyAddProfilePhoto from './Components/Agency/JobPosting/AddProfilePhoto';
import Candidates_admin from './Components/Admin/Candidates/Candidates_admin';
import CandidatesViewadmin from './Components/Admin/Candidates/CandidatesViewadmin';
import PostedJobsadmin from './Components/Admin/PostedJobs/PostedJobsadmin';
import ViewPostedJobsadmin from './Components/Admin/PostedJobs/ViewPostedJobsadmin';
import AdminDashboard from './Components/Admin/AdminDashboard/AdminDashboard';
import AdminCard from './Components/Admin/AdminDashboard/AdminCards';
import SubscriptionPlans from './Components/Employer/SubscriptionPlans/SubscriptionPlans';
import ForgotPassword from './Components/Pages/ForgotPassword/ForgotPassword';
import ManageJobpositions from './Components/Admin/ManageJobpositions/ManageJobpositions';
import ManageAbout from './Components/Admin/ManageAbout/ManageAbout';
import ManageFooterContent from './Components/Admin/ManageFooterContent/ManageFooterContent';
import ManageAvailableJobs from './Components/Admin/ManageAvailableJobs/ManageAvailableJobs';
import ManageSubscriptionplans from './Components/Admin/ManageSubscriptionplans/ManageSubscriptionplans';
import SubscriptionForm from './Components/Admin/ManageSubscriptionplans/SubscriptionForm';
import MyAccountAdmin from './Components/Admin/MyAccount/MyAccountAdmin';
import ReportedCandidates from './Components/Admin/ReportedCandidates/ReportedCandidates';
import ReportedCandidateView from './Components/Admin/ReportedCandidates/ReportedCandidateView';
import ReportedJob from './Components/Admin/ReportedJobs/ReportedJob';
import ReportedJobView from './Components/Admin/ReportedJobs/ReportedJobView';
import AgencySubscriptionPlans from './Components/Agency/JobSeekerResumeUpdate/AgencySubscriptionPlans';
import AgencyJobSubscriptionPlans from './Components/Agency/JobPosting/AgencyJobSubscriptionPlans';
import ManageAgencySubscriptionplans from './Components/Admin/ManageAgencyPlans/ManageAgencySubscriptionplans';
import AgencySubscriptionForm from './Components/Admin/ManageAgencyPlans/AgencySubscriptionForm';
import AdminSubscriptionAnalytics from './Components/Admin/ManageAgencyPlans/AdminSubscriptionAnalytics';
import ManageEmployerSubscriptionPlans from './Components/Admin/ManageEmployerPlans/ManageEmployerSubscriptionPlans';
import ManageCandidateSubscriptionPlans from './Components/Admin/ManageCandidatePlans/ManageCandidateSubscriptionPlans';
import CandidateSubscription from './Components/JobSeeker/Subscription/CandidateSubscription';
import AgencyAppliedCandidates from './Components/Agency/AppliedCandidates/AgencyAppliedCandidates';
import PreviousExp from './Components/JobSeeker/ResumeUpdate/DoctorProfile/PreviousExp/PreviousExp';
import Qualifications from './Components/JobSeeker/ResumeUpdate/DoctorProfile/Qualifications/Qualifications';

import JobPreference from './Components/JobSeeker/ResumeUpdate/DoctorProfile/JobPreference/JobPreference';
import ProfessionalInformation from './Components/JobSeeker/ResumeUpdate/DoctorProfile/ProfessionalInformation/ProfessionalInformation';


import ManageShortlist from "./Components/Admin/ManageShortlist/ManageShortlist"
import ShortlistDetails from "./Components/Admin/ManageShortlist/ShortlistDetails"


import AdminJobs from "./Components/Admin/ManageJobs/ManageJobs"
import AdminEmployee from "./Components/Admin/ManageEmployee/ManageEmployee"



// import JobPreference from './Components/JobSeeker/ResumeUpdate/DoctorProfile/JobPreference/JobPreference';
import Experience from './Components/JobSeeker/ResumeUpdate/DoctorProfile/Experience/Experience';
import PreferenceJob from './Components/JobSeeker/ResumeUpdate/DoctorProfile/PreferenceJob/PreferenceJob';
// import ProfessionalInformation from './Components/JobSeeker/ResumeUpdate/DoctorProfile/ProfessionalInformation/ProfessionalInformation';
import AboutDetails from './Components/JobSeeker/ResumeUpdate/DoctorProfile/AboutDetails/AboutDetails';
import Drprofileview1 from './Components/JobSeeker/ResumeUpdate/DoctorProfile/ProfileView/Drprofileview1';
import DrProfileView2 from './Components/JobSeeker/ResumeUpdate/DoctorProfile/ProfileView/DrProfileView2';
import AgencyAboutDetails from './Components/Agency/JobSeekerResumeUpdate/DoctorProfile/AboutDetails/AgencyAboutDetails';
import AgencyExperience from './Components/Agency/JobSeekerResumeUpdate/DoctorProfile/Experience/AgencyExperience';
import AgencyJobPreference from './Components/Agency/JobSeekerResumeUpdate/DoctorProfile/JobPreference/AgencyJobPreference';
import AgencyPreferenceJob from './Components/Agency/JobSeekerResumeUpdate/DoctorProfile/PreferenceJob/AgencyPreferenceJob';
import AgencyProfessionalInformation from './Components/Agency/JobSeekerResumeUpdate/DoctorProfile/ProfessionalInformation/AgencyProfessionalInformation';
import AgencyQualifications from './Components/Agency/JobSeekerResumeUpdate/DoctorProfile/Qualifications/AgencyQualifications';
import Doctor from './Components/Home/Doctor/Doctor';

import PayNow from './Components/OtherPages/PayNow/PayNow';

import EmployerContactUs from './Components/Employer/ContactUs/EmployerContactUs';
import EmployeeContactUs from './Components/JobSeeker/ContactUs/EmployeeContactUs';
import ManageNews from './Components/Admin/ManageNews/ManageNews';
import ManageTips from './Components/Admin/ManageTips/ManageTips';
import Training from './Components/Home/Training/Training';
import FAQs from './Components/Home/FAQs/FAQs';
import SupportMessages from './Components/Admin/SupportMessages/SupportMessages';
import EnquiryDetail from './Components/Admin/EnquiryDetail/EnquiryDetail';
import AgencyEnquiryDetail from './Components/Agency/AgencyEnquiryDetail/AgencyEnquiryDetail';
import EmployeeNews from './Components/JobSeeker/NewsandTips/EmployeeNews';
import EmployeeTips from './Components/JobSeeker/NewsandTips/EmployeeTips';
import ManageTrainings from './Components/Admin/ManageTrainings/ManageTrainings';
import TermsandConditions from './Components/TermsandConditions/TermsandConditions';
import PrivacyPolicy from './Components/PrivacyPolicy/PrivacyPolicy';
import ReturnRefundsandCancellation from './Components/ReturnRefundsandCancellation/ReturnRefundsandCancellation';
import ShipDeliveryPolicy from './Components/ShipDeliveryPolicy/ShipDeliveryPolicy';



// import DoctorView from './Components/Home/Doctor/DoctorView';

import EmployerNews from './Components/Employer/NewsandTips/EmployerNews';
import EmployerTips from './Components/Employer/NewsandTips/EmployerTips';
import IndividualTraining from "./Components/Home/Training/IndividualTraining";


// Add this import at the top with other imports
import CreateNews from './Components/Admin/ManageNews/CreateNews';

// In App.js, add these imports:
import CreateTip from './Components/Admin/ManageTips/CreateTips';
import AddTraining from './Components/Admin/ManageTrainings/AddTraining';
import AdminInstantMessage from './Components/Admin/AdminOutreach/AdminInstantMessage';
import AdminBulkOutreach from './Components/Admin/AdminOutreach/AdminBulkOutreach';


import JobSeekerAboutUs from "./Components/JobSeeker/AboutUs/AboutUs"
import JobSeekerContactUs from "./Components/JobSeeker/ContactUs/EmployeeContactUs"
import JobSeekerTipsNews from "./Components/JobSeeker/TipsNews/TipsNews"
import ArticleDetail from './Components/JobSeeker/TipsNews/ArticleDetail';
import AgencyArticleDetail from './Components/Agency/TipsNews/ArticleDetailAgency';
import JobSeekerTraining from "./Components/JobSeeker/Training/Training"
import JobSeeekerIndividualTraining from "./Components/JobSeeker/Training/IndividualTraining"
import JobSeekerFAQ from "./Components/JobSeeker/FAQs/FAQs"
import JobSeekerTermsandConditions from "./Components/JobSeeker/TermsandConditions/TermsandConditions"
import JobSeekerPrivacyPolicy from "./Components/JobSeeker/PrivacyPolicy/PrivacyPolicy"
import JobSeekerReturnRefundsandCancellation from "./Components/JobSeeker/ReturnRefundsandCancellation/ReturnRefundsandCancellation"
import JobSeekerShipDeliveryPolicy from "./Components/JobSeeker/ShipDeliveryPolicy/ShipDeliveryPolicy"


import EmployerNurse from "./Components/Employer/Nurse/Nurse"
import EmployerDomesticHelper from "./Components/Employer/DomesticHelper/DomesticHelper"
import EmployerDoctor from "./Components/Employer/Doctor/Doctor"

import EmployeeAboutUs from "./Components/Employer/AboutUs/AboutUs"
import EmployeeContact from "./Components/Employer/ContactUs/EmployerContactUs"
import EmployeeTipsNews from "./Components/Employer/NewsandTips/EmployerNews"
import EmployeeTraining from "./Components/Employer/Training/Training"
import EmployeeIndividualTraining from "./Components/Employer/Training/IndividualTraining"
import EmployeeFAQ from "./Components/Employer/FAQs/FAQs"
// import EmployerFAQ from "./Components/Employer/FAQs/FAQs"
import EmployeeTermsandConditions from "./Components/Employer/TermsandConditions/TermsandConditions"
import EmployeePrivacyPolicy from "./Components/Employer/PrivacyPolicy/PrivacyPolicy"
import EmployeeReturnRefundsandCancellation from "./Components/Employer/ReturnRefundsandCancellation/ReturnRefundsandCancellation"
import EmployeeShipDeliveryPolicy from "./Components/ShipDeliveryPolicy/ShipDeliveryPolicy"



import AgencyAboutUs from "./Components/Agency/AboutUs/AboutUs"
import AgencyContact from "./Components/Agency/ContactUs/ContactUs"
import AgencyTipsNews from "./Components/Agency/TipsNews/TipsNews"
import AgencyTraining from "./Components/Agency/Training/Training"
import AgencyIndividualTraining from "./Components/Agency/Training/IndividualTraining"
import AgencyFAQ from "./Components/Agency/FAQs/FAQs"
import AgencyTermsandConditions from "./Components/Agency/TermsandConditions/TermsandConditions"
import AgencyPrivacyPolicy from "./Components/Agency/PrivacyPolicy/PrivacyPolicy"
import AgencyReturnRefundsandCancellation from "./Components/Agency/ReturnRefundsandCancellation/ReturnRefundsandCancellation"
import AgencyShipDeliveryPolicy from "./Components/Agency/ShipDeliveryPolicy/ShipDeliveryPolicy"
import AppliedCandidateView from './Components/Employer/AppliedCandidates/AppliedCandidateView';
import AgencyAppliedCandidatesView from './Components/Agency/AppliedCandidates/AgencyAppliedCandidatesView';
import ArtcleDetailsemployer from './Components/Employer/NewsandTips/ArtcleDetailsemployer';
import ArticleDetailAgency from './Components/Agency/TipsNews/ArticleDetailAgency';
import ManageallAgency from './Components/Admin/ManageallAgency/ManageallAgency';
import AgencyProfileView from './Components/Employer/Candidates/AgencyProfileView';

// import NewEmployerDashboard from './Components/Employer/Dashboard/EmployeeDashboard/EmployerDashboard';
import NewCandidateDashboard from "./Components/JobSeeker/Dashboard/NewDashboard"


import CustomerDashboardPage from "./Components/JobSeeker/Dashboard/NewDashboard";

import PaymentSuccessPage from "./Components/Employer/SubscriptionPlans/PaymentSuccess"
import AdminPersonalInfo from './Components/Admin/CandidateEdit/AdminPersonalInfo';
import AdminContactDetails from './Components/Admin/CandidateEdit/AdminContactDetails';
import AdminProfessionalInfo from './Components/Admin/CandidateEdit/AdminProfessionalInfo';
import AdminPreferenceForJob from './Components/Admin/CandidateEdit/AdminPreferenceForJob';
import AdminMySkills from './Components/Admin/CandidateEdit/AdminMySkills';
import AdminPreviousExperience from './Components/Admin/CandidateEdit/AdminPreviousExperience';
import AdminEducation from './Components/Admin/CandidateEdit/AdminEducation';
import AdminResume from './Components/Admin/CandidateEdit/AdminResume';
import AdminUploadVideo from './Components/Admin/CandidateEdit/AdminUploadVideo';
import AdminChoosePhoto from './Components/Admin/CandidateEdit/AdminChoosePhoto';

const AllCandidates = lazy(() => import('./Components/Home/Candidates/Candidates'));
const AllCandidateDetails = lazy(() => import('./Components/Home/Candidates/CandidateDetails'));
const Nurse = lazy(() => import('./Components/Home/Nurse/Nurse'));
const Driver = lazy(() => import('./Components/Home/Driver/Driver'));
const Cook = lazy(() => import('./Components/Home/Cook/Cook'));
const DomesticHelper = lazy(() => import('./Components/Home/DomesticHelper/DomesticHelper'));


function App() {
  return (
    <SocketProvider>
      <GlobalCallNotificationWrapper />
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Suspense fallback={<div className="container py-5 text-center">Loading...</div>}>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/tips-news" element={<TipsNews />} />
        <Route path="/terms-and-conditions" element={<TermsandConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/returns-refunds-cancellation" element={<ReturnRefundsandCancellation />} />
        <Route path="/shipping-delivery-policy" element={<ShipDeliveryPolicy />} />

        <Route path="/jobseeker-aboutus" element={<JobSeekerAboutUs />} />
        <Route path="/jobseeker-contactus" element={<JobSeekerContactUs />} />
        <Route path="/jobseeker-tips-news" element={<JobSeekerTipsNews />} />
        <Route path="/jobseeker-training" element={<JobSeekerTraining />} />
        <Route path="/jobseeker-individual-training" element={<JobSeeekerIndividualTraining />} />
        <Route path="/jobseeker-faqs" element={<JobSeekerFAQ />} />

        <Route path="/jobseeker-terms-and-conditions" element={<JobSeekerTermsandConditions />} />
        <Route path="/jobseeker-privacy-policy" element={<JobSeekerPrivacyPolicy />} />
        <Route path="/jobseeker-returns-refunds-cancellation" element={<JobSeekerReturnRefundsandCancellation />} />
        <Route path="/jobseeker-shipping-delivery-policy" element={<JobSeekerShipDeliveryPolicy />} />
        <Route path="/articledetailsagency/:id" element={<ArticleDetailAgency />} />



        <Route path="/employee-aboutus" element={<EmployeeAboutUs />} />
        <Route path="/employee-contactus" element={<EmployeeContact />} />
        <Route path="/employee-tips-news" element={<EmployeeTipsNews />} />
        <Route path="/employee-training" element={<EmployeeTraining />} />
        <Route path="/employee-individual-training" element={<EmployeeIndividualTraining />} />
        <Route path="/employer-faqs" element={<EmployeeFAQ />} />
        {/* <Route path="/employer-faqs" element={<EmployerFAQ />} /> */}
        <Route path="/employee-terms-and-conditions" element={<EmployeeTermsandConditions />} />
        <Route path="/employee-privacy-policy" element={<EmployeePrivacyPolicy />} />
        <Route path="/employee-returns-refunds-cancellation" element={<EmployeeReturnRefundsandCancellation />} />
        <Route path="/employee-shipping-delivery-policy" element={<EmployeeShipDeliveryPolicy />} />



        <Route path="/agency-aboutus" element={<AgencyAboutUs />} />
        <Route path="/agency-contactus" element={<AgencyContact />} />
        <Route path="/agency-tips-news" element={<AgencyTipsNews />} />
        <Route path="/agency-training" element={<AgencyTraining />} />
        <Route path="/agency-individual-training" element={<AgencyIndividualTraining />} />
        <Route path="/agency-faqs" element={<AgencyFAQ />} />
        <Route path="/agency-terms-and-conditions" element={<AgencyTermsandConditions />} />
        <Route path="/agency-privacy-policy" element={<AgencyPrivacyPolicy />} />
        <Route path="/agency-returns-refunds-cancellation" element={<AgencyReturnRefundsandCancellation />} />
        <Route path="/agency-shipping-delivery-policy" element={<AgencyShipDeliveryPolicy />} />
        <Route path="/agencydashboard" element={<NewAgencyDashboard />} />
        <Route path="/agency-dashboard" element={<NewAgencyDashboard />} />
        <Route path="/agency/dashboard" element={<NewAgencyDashboard />} />

        {/* Agency App Routes */}
        <Route path="/a-viewcandidates" element={<ViewCandidates />} />
        <Route path="/a-jobposting" element={<JobPosting />} />
        <Route path="/a-myaccount" element={<AgencyMyaccount />} />
        <Route path="/agencyappliedcandidates" element={<AgencyAppliedCandidates />} />
        <Route path="/agencyappliedcandidatesview/:userId" element={<AgencyAppliedCandidatesView />} />
        <Route path="/agency-messages" element={<AgencyMessages />} />
        <Route path="/agency-enquiries" element={<AgencyEnquiryDetail />} />
        <Route path="/agency-send-alert" element={<AgencySendAlert />} />
        <Route path="/a-subscriptionplans" element={<AgencySubscriptionPlans />} />
        <Route path="/a-jobsubscriptionplans" element={<AgencyJobSubscriptionPlans />} />
        <Route path="/addjobseeker" element={<AddJobSeeker />} />
        <Route path="/jobseekerregistration" element={<JobSeekerRegistration />} />
        <Route path="/a-agencyviewcandidates/:userId" element={<AgencyViewCandidates />} />
        <Route path="/a-agencyviewcandidates/:userId/:first_name" element={<AgencyViewCandidates />} />
        <Route path="/agencyviewcandidates/:userId/:first_name" element={<AgencyViewCandidates />} />
        <Route path="/agencyprofile/:id" element={<AgencyProfileView />} />
        <Route path="/candidateview/:userId" element={<CandidateView />} />
        <Route path="/candidateview/:userId/:first_name" element={<CandidateView />} />

        {/* Agency Candidate Posting Flow */}
        <Route path="/a-personalinfo" element={<Personalinfo />} />
        <Route path="/a-contactdetails" element={<Contactdetails />} />
        <Route path="/a-professionalinfo" element={<Professionalinfo />} />
        <Route path="/a-preference" element={<Preferenceforjob />} />
        <Route path="/a-myskills" element={<Myskills />} />
        <Route path="/a-previous" element={<Previousexperience />} />
        <Route path="/a-education" element={<Education1 />} />
        <Route path="/a-resume" element={<Resume />} />
        <Route path="/a-uploadvideo" element={<Uploadvideo />} />
        <Route path="/a-choosephoto" element={<Choosephoto />} />
        <Route path="/a-aboutdetails" element={<AgencyAboutDetails />} />
        <Route path="/a-professionalinformation" element={<AgencyProfessionalInformation />} />
        <Route path="/a-preferencejob" element={<AgencyPreferenceJob />} />
        <Route path="/a-jobpreference" element={<AgencyJobPreference />} />
        <Route path="/a-experience" element={<AgencyExperience />} />
        <Route path="/a-qualifications" element={<AgencyQualifications />} />

        {/* Agency Job Posting Flow */}
        <Route path="/a-basicinfo" element={<AgencyBasicInfo />} />
        <Route path="/a-requiredskills" element={<AgencyRequiredSkills />} />
        <Route path="/a-candidatepreference" element={<AgencyCandidatePreference />} />
        <Route path="/a-aboutyourself" element={<AgencyAboutYourself />} />
        <Route path="/a-jobdescription" element={<AgencyJobDescriptionForm />} />
        <Route path="/a-addprofilephoto" element={<AgencyAddProfilePhoto />} />
        <Route path="/a-viewjobdetails" element={<AgencyViewJobDetails />} />
        <Route path="/a-viewjobdetails/:jobId" element={<AgencyViewJobDetails />} />


        <Route path="/footer" element={<Footer />} />
        <Route path="/register" element={<Register />} />
        <Route path="/navbar" element={<Navbar />} />
        <Route path="/login" element={<Login />} />
        <Route path="/employernavbar" element={<EmployerNavbar />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />



        {/* Initial Routes */}
        <Route path="/alljobs" element={<AllJobs />} />
        <Route path="/jobineurope" element={<EuropeanJobs />} />
        <Route path="/alljobdetails" element={<AllJobDetails />} />
        <Route path="/alljobdetails/:jobId" element={<AllJobDetails />} />
        <Route path="/allcandidates" element={<AllCandidates />} />
        <Route path="/nurse" element={<Nurse />} />
        <Route path="/doctor" element={<Doctor />} />
        <Route path="/driver" element={<Driver />} />
        <Route path="/cook" element={<Cook />} />
        <Route path="/domestichelper" element={<DomesticHelper />} />
        <Route path="/allcandidatesdetails/:userId" element={<AllCandidateDetails />} />

        {/* JobSeeker Routes */}
        <Route path="/personalinfo" element={<PersonalInfo />} />
        <Route path="/contactdetails" element={<ContactDetails />} />
        <Route path="/professionalinfo" element={<ProfessionalInfo />} />
        <Route path="/preference" element={<PreferenceForJob />} />
        <Route path="/myskills" element={<MySkills />} />
        <Route path="/previous" element={<PreviousExperience />} />
        <Route path="/education" element={<Education />} />
        <Route path="/resume" element={<ResumeDescription />} />
        <Route path="/uploadvideo" element={<UploadVideo />} />
        <Route path="/choosephoto" element={<ChoosePhoto />} />
        <Route path="/jobseeker-dashboard" element={<JobSeekerDashboard />} />
        <Route path="/profile-card" element={<ProfileCard />} />
        <Route path="/viewjobs" element={<ViewJobs />} />
        <Route path="/jobdetails" element={<JobDetails />} />
        <Route path="/jobdetails/:jobId" element={<JobDetails />} />
        <Route path="/appliedjobs" element={<AppliedJobs />} />
        <Route path="/appliedjobdetails" element={<AppliedJobDetails />} />
        <Route path="/myaccount" element={<MyAccount />} />
        <Route path="/combinedprofilecard" element={<CombinedProfileCard />} />
        <Route path="/jobpreference" element={<JobPreference />} />

        <Route path="/preferencejob" element={<PreferenceJob />} />

        <Route path="/professionalinformation" element={<ProfessionalInformation />} />
        <Route path="/aboutdetails" element={<AboutDetails />} />
        <Route path="/drprofileview1" element={<Drprofileview1 />} />
        <Route path="/drprofileview2" element={<DrProfileView2 />} />
        {/* <Route path="/employeecontactus" element={<EmployeeContactUs />} /> */}
        <Route path="/employeenews" element={<EmployeeNews />} />
        <Route path="/employeetips" element={<EmployeeTips />} />
        <Route path="/employetips" element={<EmployeeTips />} />
        <Route path="/jobseeker-messages" element={<JobSeekerMessages />} />


        {/* Employer App Routes */}
        <Route path="/employer-dashboard" element={<EmployerDashboard />} />
        <Route path="/employerdashboard" element={<EmployerDashboard />} />
        <Route path="/employer/dashboard" element={<EmployerDashboard />} />
        <Route path="/viewjobposting" element={<ViewJobposting />} />
        <Route path="/viewjobdetails" element={<ViewJobDetails />} />
        <Route path="/viewjobdetails/:jobId" element={<ViewJobDetails />} />
        <Route path="/basicinfo" element={<BasicInfo />} />
        <Route path="/requiredskills" element={<RequiredSkills />} />
        <Route path="/candidatepreference" element={<CandidatePreference />} />
        <Route path="/aboutyourself" element={<AboutYourself />} />
        <Route path="/jobdescription" element={<JobDescription />} />
        <Route path="/addprofilephoto" element={<AddProfilePhoto />} />
        <Route path="/candidates" element={<Candidates />} />
        <Route path="/appliedcandidates" element={<AppliedCandidates />} />
        <Route path="/appliedcandidateview" element={<AppliedCandidateView />} />
        <Route path="/appliedcandidateview/:userId" element={<AppliedCandidateView />} />
        <Route path="/employer-messages" element={<EmployerMessages />} />
        <Route path="/employer-send-alert" element={<SendAlert />} />
        <Route path="/subscriptionplans" element={<SubscriptionPlans />} />
        <Route path="/employer/subscriptionplans" element={<SubscriptionPlans />} />
        <Route path="/myprofile" element={<MyProfile />} />
        <Route path="/emp-nurse" element={<EmployerNurse />} />
        <Route path="/emp-domestic" element={<EmployerDomesticHelper />} />
        <Route path="/emp-doctor" element={<EmployerDoctor />} />
        <Route path="/agencies" element={<AgencyList />} />

        {/* Admin Routes */}
        <Route path="/viewpostedjobsadmin" element={<ViewPostedJobsadmin />} />
        <Route path="/admindashboard" element={<AdminDashboard />} />
        <Route path="/admin-card" element={<AdminCard />} />
        <Route path="/admin-lead-bot-leads" element={<AdminLeadBotLeads />} />
        <Route path="/admin-payments" element={<AdminPayments />} />
        <Route path="/managejobpositions" element={<ManageJobpositions />} />
        <Route path="/manageabout" element={<ManageAbout />} />
        <Route path="/managefootercontent" element={<ManageFooterContent />} />
        <Route path="/manageavailablejobs" element={<ManageAvailableJobs />} />
        <Route path="/managesubscriptionplans" element={<ManageSubscriptionplans />} />
        <Route path="/subscriptionform" element={<SubscriptionForm />} />
        <Route path="/subscriptionform/:id" element={<SubscriptionForm />} />
        <Route path="/myaccountadmin" element={<MyAccountAdmin />} />
        <Route path="/reportedcandidatesadmin" element={<ReportedCandidates />} />
        <Route path="/reportedcandidateview" element={<ReportedCandidateView />} />
        <Route path="/reportedcandidateview/:candidateId" element={<ReportedCandidateView />} />
        <Route path="/reportedjob" element={<ReportedJob />} />
        <Route path="/reportedjobview" element={<ReportedJobView />} />
        <Route path="/reportedjobview/:jobId" element={<ReportedJobView />} />
        <Route path="/managenews" element={<ManageNews />} />
        <Route path="/managetips" element={<ManageTips />} />
        <Route path="/createtip/:id" element={<CreateTip />} />
        <Route path="/supportmessages" element={<SupportMessages />} />
        <Route path="/enquiry-detail" element={<EnquiryDetail />} />
        <Route path="/managetrainings" element={<ManageTrainings />} />
        <Route path="/add-training" element={<AddTraining />} />
        <Route path="/manageallagency" element={<ManageallAgency />} />

        <Route path="/createnews" element={<CreateNews />} />
        <Route path="/createnews/:id" element={<CreateNews />} />
        <Route path="/article/:id" element={<ArticleDetail />} />
        <Route path="/agency-article/:id" element={<ArticleDetail />} />
        <Route path="/createtip" element={<CreateTip />} />
        <Route path="/admin-instant-message" element={<AdminInstantMessage />} />
        <Route path="/admin-bulk-outreach" element={<AdminBulkOutreach />} />

        {/* Admin Candidate resume Pageses diting routes */}

        <Route path="/adminpersonalinfo" element={<AdminPersonalInfo />} />
        <Route path="/admincontactdetails" element={<AdminContactDetails />} />
        <Route path="/adminprofessionalinfo" element={<AdminProfessionalInfo />} />
        <Route path="/adminpreference" element={<AdminPreferenceForJob />} />
        <Route path="/adminmyskills" element={<AdminMySkills />} />
        <Route path="/adminprevious" element={<AdminPreviousExperience />} />
        <Route path="/admineducation" element={<AdminEducation />} />
        <Route path="/adminresume" element={<AdminResume />} />
        <Route path="/adminuploadvideo" element={<AdminUploadVideo />} />
        <Route path="/adminchoosephoto" element={<AdminChoosePhoto />} />

        <Route path="/previousexp" element={<PreviousExp />} />
        <Route path="/qualifications" element={<Qualifications />} />
        <Route path="/experince" element={<Experience />} />
        <Route path="/dropprofileview1" element={<Drprofileview1 />} />
        <Route path="/dropprofileview2" element={<DrProfileView2 />} />
        <Route path="/paynow" element={<PayNow />} />
        {/* <Route path="/doctorview" element={<DoctorView />} /> */}

        <Route path="/training" element={<Training />} />
        <Route path="/individual-training" element={<IndividualTraining />} />
        <Route path="/faqs" element={<FAQs />} />

        {/* <Route path="/new-employer-dashboard" element={<NewEmployerDashboard />} /> */}
        <Route path="/new-candidate-dashboard" element={<NewCandidateDashboard />} />

        <Route path="/customer-dashboard" element={<CustomerDashboardPage />} />

        <Route path="/payment-success" element={<PaymentSuccessPage />} />

        {/* Verification and Management Routes */}
        <Route path="/manageemployee" element={<AdminEmployee />} />
        <Route path="/managejobs" element={<AdminJobs />} />
        <Route path="/manageshortlist" element={<ManageShortlist />} />

        {/* Subscription Plan Management Routes */}
        <Route path="/managecandidatesubscriptionplans" element={<ManageCandidateSubscriptionPlans />} />
        <Route path="/manageemployersubscriptionplans" element={<ManageEmployerSubscriptionPlans />} />
        <Route path="/manageagencysubscriptionplans" element={<ManageAgencySubscriptionplans />} />

        {/* View Details Routes */}
        <Route path="/candidatesviewadmin/:userId" element={<CandidatesViewadmin />} />




      </Routes>
      </Suspense>
    </Router>
    </SocketProvider>
  );
}

export default App;
